import AddTipPage, { AddTipPageProps } from './AddTipPage';

export type { AddTipPageProps };
export default AddTipPage;
